import {Text} from '../../../../../../../../../component/text/text';
import {Spinner} from '../../../../../../../../../layout/spinner/spinner';
import {Locale} from '../../../../../../../../../provider/locale/localization';

import * as styles from './generation-loading-step.scss';

type PropsType = {
    isSlowImageGeneration: boolean;
};

export function GenerationLoadingStep(props: PropsType): JSX.Element {
    const {isSlowImageGeneration} = props;

    return (
        <div className={styles.GenerationLoadingStep}>
            <Spinner />
            <Locale stringKey="POSTS_AI_GENERATION__LOADING" />

            {isSlowImageGeneration && (
                <Text
                    className={styles.GenerationLoadingStep_hint}
                    secondary
                    small
                    stringKey="POSTS_AI_GENERATION__IMAGE__SLOW_GENERATION_HINT"
                />
            )}
        </div>
    );
}
